'use client';

import { toast } from 'sonner';
import { fetchApi, ApiResponseError } from '@/lib/api/fetch-api';

export const USAGE_COLOR_CLASSES = {
  green: 'bg-emerald-500',
  yellow: 'bg-amber-500',
  red: 'bg-red-500',
} as const;

export async function redirectToCheckout(): Promise<void> {
  try {
    const { data } = await fetchApi<{ data: { url: string } }>('/api/stripe/checkout', { method: 'POST' });
    if (data?.url) {
      window.location.href = data.url;
    }
  } catch (error) {
    if (error instanceof ApiResponseError) {
      toast.error('Failed to start checkout. Please try again.');
      return;
    }
    throw error;
  }
}

export async function redirectToPortal(): Promise<void> {
  try {
    const { data } = await fetchApi<{ data: { url: string } }>('/api/stripe/portal', { method: 'POST' });
    if (data?.url) {
      window.location.href = data.url;
    }
  } catch (error) {
    if (error instanceof ApiResponseError) {
      toast.error('Failed to open billing portal. Please try again.');
      return;
    }
    throw error;
  }
}

export function getUsageColor(used: number, limit: number): 'green' | 'yellow' | 'red' {
  if (limit <= 0) return 'green';
  const pct = (used / limit) * 100;
  if (pct >= 100) return 'red';
  if (pct >= 80) return 'yellow';
  return 'green';
}
